<template>

  <div @click="openAHref" class="text-block">
    <slot></slot>
  </div>

</template>

<script>


export default {
  name: 'text-block',
  data:function(){
    return {
    }
  },
  components:{
    
  },
  methods:{
    openAHref(e){
    
  
    if(e.target.tagName!="A"){
      return;
    }

    

    // get literal href from attribute
    var href=e.target.getAttribute("href");
    if (href.indexOf("http://") == -1 && href.indexOf("https://") == -1) {
        // let browser decide by prefixing with "//"
        
        href="http://"+href;
        e.target.setAttribute("href",href);
        
    }

    e.target.target="_blank";
   
    },
  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-block{
  margin-bottom:10px;
  color:inherit;
  white-space:pre-wrap;
}



</style>

